/**
 * ROCK AND RELIGION - CUSTOM HEADER BEHAVIOR
 * Cambia header de negro a blanco en scroll y hover
 * Desktop: scroll + hover
 * Mobile: solo scroll (pero NO cuando drawer está abierto)
 */

(function() {
  'use strict';

  // Configuración
  const CONFIG = {
    scrollThreshold: 50,
    headerSelector: '[data-header-wrapper]',
    drawerSelector: 'nav.drawer.header__drawer',
    whiteClass: 'header--white',
    mobileBreakpoint: 1024
  };

  // Variables globales
  let header = null;
  let drawer = null;
  let isScrolled = false;
  let isHovered = false;
  let isDrawerOpen = false;

  /**
   * Detectar si estamos en móvil
   */
  function isMobile() {
    return window.innerWidth < CONFIG.mobileBreakpoint;
  }

  /**
   * Detectar si el drawer está abierto
   */
  function checkDrawerState() {
    if (!drawer) return false;
    
    // El drawer está abierto si tiene la clase 'drawer--visible'
    // o si NO tiene la clase 'display-none'
    const isVisible = drawer.classList.contains('drawer--visible');
    const isNotHidden = !drawer.classList.contains('display-none');
    
    return isVisible || isNotHidden;
  }

  /**
   * Inicializar
   */
  function init() {
    header = document.querySelector(CONFIG.headerSelector);
    drawer = document.querySelector(CONFIG.drawerSelector);
    
    if (!header) {
      console.warn('Header no encontrado');
      return;
    }

    if (!drawer) {
      console.warn('Drawer no encontrado');
    }

    // Event listeners
    window.addEventListener('scroll', handleScroll);
    
    // Hover solo en desktop
    header.addEventListener('mouseenter', handleMouseEnter);
    header.addEventListener('mouseleave', handleMouseLeave);

    // Observer para detectar cambios en el drawer
    if (drawer) {
      observeDrawer();
    }

    // Check inicial
    handleScroll();
  }

  /**
   * Observer para detectar cuando se abre/cierra el drawer
   */
  function observeDrawer() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          isDrawerOpen = checkDrawerState();
          updateHeaderState();
        }
      });
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /**
   * Manejar scroll
   */
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    isScrolled = scrollTop > CONFIG.scrollThreshold;
    updateHeaderState();
  }

  /**
   * Manejar mouse enter (solo desktop)
   */
  function handleMouseEnter() {
    if (isMobile()) return;
    isHovered = true;
    updateHeaderState();
  }

  /**
   * Manejar mouse leave (solo desktop)
   */
  function handleMouseLeave() {
    if (isMobile()) return;
    isHovered = false;
    updateHeaderState();
  }

  /**
   * Actualizar estado del header
   */
  function updateHeaderState() {
    // SI EL DRAWER ESTÁ ABIERTO: NUNCA aplicar clase blanca
    if (isDrawerOpen) {
      header.classList.remove(CONFIG.whiteClass);
      return;
    }

    // Desktop: scroll O hover → blanco
    // Mobile: solo scroll → blanco
    
    if (isMobile()) {
      // En mobile: solo scroll
      if (isScrolled) {
        header.classList.add(CONFIG.whiteClass);
      } else {
        header.classList.remove(CONFIG.whiteClass);
      }
    } else {
      // En desktop: scroll O hover
      if (isScrolled || isHovered) {
        header.classList.add(CONFIG.whiteClass);
      } else {
        header.classList.remove(CONFIG.whiteClass);
      }
    }
  }

  /**
   * Ejecutar cuando DOM esté listo
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();